import { Avatar } from "@material-ui/core";
import React from "react";
import store from "redux/Store";

const getSharedGroups = (classes, data, orgGroups) => {

  const {
    orgRuntime: {
      runtime: {
        _mlCfSharePermissionOptions
      }
    } 
  } = store.getState();

  if (data && data.length)
{
  return (
    data && data.map((v) => {
      var orgGroup = orgGroups?.find((r) => r.groupId === v.id);
      return (
        <div className={classes.sharedUserList}>
          <Avatar
            alt={orgGroup?.name}
            src={orgGroup?.imageUrl}
            className={classes.smallAvatar}
          ></Avatar>
          <div className={classes.sharedUserListSinglePreview}>
            <div title={orgGroup?.name + " " +  (orgGroup?.bbcCompany || "") + " " + (orgGroup?.bbcDepartment || "")} className={classes.sharedUserListName}>{orgGroup?.name + " " +  (orgGroup?.bbcCompany || "") + " " + (orgGroup?.bbcDepartment || "")}</div>
          </div>
          <div title= {_mlCfSharePermissionOptions.find(e => e.id == v.permission).name || ""} className={classes.sharedUserPermission}>
          {_mlCfSharePermissionOptions.find(e => e.id == v.permission).name || ""}
          </div>
        </div>
      );
    })
  );
}
else{
  return <div className={classes.underConstructionMessage} >Not Shared</div>
}
};

export default ({ label, data, classes, orgGroups }) => {
  return (
    <div className={classes.sharePlaylistUsers}>
      <div title={label} className={classes.sharePlaylistUsersLabel}>{label}</div>
      <div className={classes.sharedUserListPreview}>
      {getSharedGroups(classes, data, orgGroups)}
      </div>
    </div>
  );
};